import React from "react";
import MasterLayout from "../layouts/master";
import { graphql } from "gatsby";
import { Box, Container, SimpleGrid, chakra, VStack } from "@chakra-ui/react";

const WebPlayerIndex = (props) => {
  const { data } = props;
  return (
    <MasterLayout>
      <Container maxW={"7xl"}>
        <SimpleGrid py={12} columns={{ lg: 3, md: 3, sm: 2, base: 1 }} spacing={4}>
          {data.serverGql.getAllClassesAndMeta.classes.filter((c) => c.name != "Kids Section" && c.name != "Grammar").map((cl) => {
            return (
              <a href={`/${cl.name.toLowerCase().split(" ").join("-")}-cbse`}>
                <Box
                  maxW="container.sm"
                  borderWidth="1px"
                  borderRadius="lg"
                  overflow="hidden"
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"}
                  p={6}
                >
                  <VStack alignItems={"start"}>
                    <chakra.h2 fontWeight={"bold"} fontSize={"4xl"}>
                      {cl.name}
                    </chakra.h2>
                    <chakra.h3 fontSize={"md"}>
                      Chapters{" "}
                      <b>{` ${
                        data.serverGql.getAllClassesAndMeta.meta.find(
                          (m) => m.classId == cl.id
                        ).chapters
                      }`}</b>
                    </chakra.h3>
                    <chakra.h3 fontSize={"md"}>
                      Lectures{" "}
                      <b>{` ${
                        data.serverGql.getAllClassesAndMeta.meta.find(
                          (m) => m.classId == cl.id
                        ).lectures
                      }`}</b>
                    </chakra.h3>
                  </VStack>
                </Box>
              </a>
            );
          })}
        </SimpleGrid>
      </Container>
    </MasterLayout>
  );
};

export default WebPlayerIndex;

export const query = graphql`
  query MyQuery {
    serverGql {
      getAllClassesAndMeta {
        classes {
          id
          name
        }
        meta {
          chapters
          classId
          lectures
        }
      }
    }
  }
`;
